import { refreshAccountSummary } from "../../AccountSummary.slice";
import { AppDispatch } from "../../store/store";
import { pushToast } from "../Toaster/Toaster.slice";
import { refreshPaymentMethods } from "./PaymentMethods.slice";

/**
 * Reloads the payment methods page data after a mutation has already committed on the server.
 *
 * Never rejects. Callers await this after a successful write, so propagating a refresh failure
 * would surface an already-applied change as a failed one and invite the user to retry it. Neither
 * slice's `error` state is rendered, so a failed refresh is reported here instead of being silent.
 */
export const refreshPaymentMethodsPage = async (
  dispatch: AppDispatch
): Promise<void> => {
  const results = await Promise.allSettled([
    dispatch(refreshPaymentMethods()).unwrap(),
    dispatch(refreshAccountSummary()).unwrap(),
  ]);

  if (results.some((result) => result.status === "rejected")) {
    dispatch(
      pushToast({
        message:
          "Your changes were saved, but this page could not be refreshed. Reload to see the latest.",
        type: "error",
      })
    );
  }
};
